import { useRenderContext } from '@/shared/contexts/RenderContext'
import { useAppRouter } from '@/shared/hooks/useAppRouter'
import { isInNativeWebView } from '@/shared/lib/native-bridge/detect'

import { executeHandleNoTicket } from './no-ticket'
import { executeRequireAuth } from './require-auth'
import { executeSignOut } from './sign-out'
import type { AuthActions, Navigate, SignOutOptions } from './types'

export type { AuthActions, SignOutOptions }

function makeActions(inNativeAppWebView: boolean, navigate: Navigate): AuthActions {
  return {
    signOut: (opts?: SignOutOptions) => executeSignOut(inNativeAppWebView, opts),
    requireAuth: (callbackUrl?: string) => executeRequireAuth(inNativeAppWebView, callbackUrl, navigate),
    handleNoTicket: (slug?: string) => executeHandleNoTicket(inNativeAppWebView, slug, navigate),
  }
}

export function useAuthActions(): AuthActions {
  const { inNativeAppWebView } = useRenderContext()
  const router = useAppRouter()
  return makeActions(inNativeAppWebView, router.replace)
}

export function getAuthActions(): AuthActions {
  const native = isInNativeWebView()
  const navigate: Navigate = (url: string) => {
    if (typeof window !== 'undefined') window.location.replace(url)
  }
  return makeActions(native, navigate)
}
